// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.reset-password-form {
  display: grid;
  gap: 4px;
  padding: 12px;
  padding: 3rem;
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.reset-password-form input {
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.reset-password-form button {
  width: 100%;
  padding: 1rem;
  margin-top: 1rem;
  background-color: #0069d9;
  color: #ffffff;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.reset-password-form h2 {
  margin-bottom: 1.5rem;
}

.reset-password-form button:hover {
  background-color: #0051a8;
}

.success-message {
  color: #28a745;
  margin-top: 1rem;
  text-align: center;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.error-message {
  color: #FF3A31;
  margin-top: 1rem;
  text-align: center;
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 600px) {
  .reset-password-form input {
    font-size: 16px;
    padding: 8px;
    margin: 8px 0;
    height: auto;
  }

  .reset-password-form button {
    font-size: 16px;
    padding: 12px;
    margin: 12px 0;
    height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/ResetPassword.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;IACb,cAAc;IACd,YAAY;EACd;AACF","sourcesContent":[".reset-password-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background-color: #f5f5f5;\n}\n\n.reset-password-form {\n  display: grid;\n  gap: 4px;\n  padding: 12px;\n  padding: 3rem;\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.reset-password-form input {\n  width: 100%;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: none;\n  border-radius: 0.25rem;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.reset-password-form button {\n  width: 100%;\n  padding: 1rem;\n  margin-top: 1rem;\n  background-color: #0069d9;\n  color: #ffffff;\n  border: none;\n  border-radius: 0.25rem;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n\n.reset-password-form h2 {\n  margin-bottom: 1.5rem;\n}\n\n.reset-password-form button:hover {\n  background-color: #0051a8;\n}\n\n.success-message {\n  color: #28a745;\n  margin-top: 1rem;\n  text-align: center;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n.error-message {\n  color: #FF3A31;\n  margin-top: 1rem;\n  text-align: center;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);\n}\n\n@media screen and (max-width: 600px) {\n  .reset-password-form input {\n    font-size: 16px;\n    padding: 8px;\n    margin: 8px 0;\n    height: auto;\n  }\n\n  .reset-password-form button {\n    font-size: 16px;\n    padding: 12px;\n    margin: 12px 0;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
